import React, { Component } from 'react';
import './AutocompleteTags.css';
import '@shopify/polaris/dist/styles.css';
import { Autocomplete, TextContainer, Stack, Tag, TextStyle} from '@shopify/polaris';

interface AutocompleteTagsProps {
    options: any,
    placeholderText:string,
    onChange: Function,
    selected: Array<string>,
    listTitle: string,
    helpText: string,
    errorLoading: boolean,
    requiresTypingToFilter: boolean
}

interface AutocompleteTagsState {
    selected: Array<string>,
    inputText: string,
    options: any
}

class AutocompleteTags extends Component <AutocompleteTagsProps, AutocompleteTagsState> {
    
    constructor(props: AutocompleteTagsProps) {
        super(props);
        this.state = {
            selected: this.props.selected,
            inputText: '',
            options: this.props.options,
        };
    }

    render() {
      let placeholder = this.props.placeholderText;
      if (this.props.errorLoading) {
        placeholder = 'Error loading, please try again. If this persists, please contact support at hello@voidworks.co'
      } else if (this.props.options.length === 0) {
        placeholder = 'None available';
      }
      const textField = (
        <Autocomplete.TextField
          onChange={this.updateText}
          onFocus={this.onFocus}
          label=""
          value={this.state.inputText}
          placeholder={placeholder}
        />
      );
      return (
        <div>
          <TextStyle>{this.props.children}</TextStyle>
          <TextContainer>
            <Stack>{this.renderTags()}</Stack>
          </TextContainer>
          <br />
          <Autocomplete
            allowMultiple
            options={this.state.options}
            selected={this.state.selected}
            textField={textField}
            onSelect={this.updateSelection}
            listTitle={this.props.listTitle}
          />
          <TextStyle variation="subdued">{this.props.helpText}</TextStyle>
        </div>
      );
    }

    onFocus = () => {
      if (this.props.requiresTypingToFilter) {
        this.setState({
            options: [],
        });
      } else {
        this.setState({
          options: this.props.options,
        });
      }
    }
  
    updateText = (newValue:string) => {
      this.setState({inputText: newValue});
      this.filterAndUpdateOptions(newValue);
    };
  
    removeTag = (tag:string) => {
      let newSelected = this.state.selected;
      newSelected = newSelected.filter(t => t !== tag);
      this.setState({selected: newSelected});
      this.props.onChange(newSelected);
    };
  
    renderTags = () => {
      return this.state.selected.filter((option)=>{
        if (typeof(option) === 'string') {
          return true;
        } else if (this.props.options.length>0) {
          if (this.props.options.find((x:any) => x.value === option)) {
            return true;
          }
        }
        return false;
      }).map((option) => {
        let tagLabel = '';
        if (typeof(option) === 'string') {
          tagLabel = option.replace('_', ' ');
        } else if (this.props.options.length>0) {
          tagLabel = this.props.options.find((x:any) => x.value === option).label;
        }
        return (
          <Tag key={'option' + option} onRemove={() => this.removeTag(option)}>
            {tagLabel}
          </Tag>
        );
      });
    };
  
    filterAndUpdateOptions = (inputString:string) => {
      if (inputString.length <= 1 && this.props.requiresTypingToFilter) {
        this.setState({
          options: [],
        });
        return;
      }
  
      const filterRegex = new RegExp(inputString, 'i');
      const resultOptions = this.props.options.filter((option:any) =>
        option.label.match(filterRegex),
      );
      let endIndex = resultOptions.length - 1;
      if (resultOptions.length === 0) {
        endIndex = 0;
      }
      this.setState({
        options: resultOptions,
      });
    };
  
    updateSelection = (selected:string[]) => {
        this.setState({selected});
        this.props.onChange(selected);
    };
  }

  export default AutocompleteTags;